// pendingOrders modules
import axios from '@/api/http_client';
import {getToken} from '@/common'
import { PENDING_ORDERS_URL, ORDER_URL, CONSOLIDATED_ORDERS_URL} from '../../api/url'

// initial state
const state = {
  pendingOrders:[],
}

// actions
const actions = {
  //fetch pending order
  fetchPendingOrders(context) {
    const token = getToken();
    const config = {
      method: 'get',
      url: PENDING_ORDERS_URL,
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    axios(config)
    .then(response => {
      context.commit('fetchPendingOrders', response.data);
    }), (err => {
      commit('updateErrorMessage', err);
    })
  },
  //delete order
  deleteOrder(context,salesOrderId) {
    const token = getToken();
    const config = {
      method: 'put',
      url: `${PENDING_ORDERS_URL}cancel/${salesOrderId}`,
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    axios(config)
    .then(response => {
      context.commit('deleteOrders', response.data);
    }), (err => {
      commit('updateErrorMessage', err);
    })
  },
  //save selected order
  saveSelectedOrders(context,pendingOrders) {
    const token = getToken();
    const config = {
      method: 'put',
      url: `${ORDER_URL}set-status/`,
      data: pendingOrders,
      headers: {
        Authorization: `JWT ${token}`,
      },
    };
    axios(config)
    .then(response => {
      context.commit('save selected order', response.data);
    }), (err => {
      commit('updateErrorMessage', err);
    })
  },
  //fetch GroupLeader Code
  fetchGroupLeaderCode(context) {
     const token = getToken();
     const config = {
       method: 'get',
       url: `${MOBILE_URL}/group-code`,
       headers: {
         Authorization: `JWT ${token}`,
       },
     };
     axios(config)
     .then(response => {
       context.commit('fetchGroupLeaderCode', response.data);
     }), (err => {
       commit('updateErrorMessage', err);
     })
  },
    //refresh GroupLeader Code
    refreshGroupLeaderCode(context) {
      const token = getToken();
      const config = {
        method: 'put',
        url: `${MOBILE_URL}/group-code`,
        headers: {
          Authorization: `JWT ${token}`,
        },
      };
      axios(config)
      .then(response => {
        context.commit('refreshGroupLeaderCode', response.data);
      }), (err => {
        commit('updateErrorMessage', err);
      })
   },
};

// mutations
const mutations = {
  fetchPendingOrders(state, payload) {
    state.pendingOrders = payload
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pendingOrders.js